// react library imports
import { MagnifyingGlass } from "phosphor-react";

// style imports
import './SearchIcon.css';

const SearchIcon = ({search, setSearch}) => {
  return (
    <div className='search_field_container mues_grey_I'>
        <MagnifyingGlass className='mues_wrapper_icon'
        weight='bold'/>
        <input type="text" value={search} onChange={e=>setSearch(e.target.value)}
        placeholder="Search Icon"/>
    </div>
  )
}

export default SearchIcon